import Vue from "vue";
import Router from "vue-router";
import Features from "./views/Features.vue";

Vue.use(Router);

export default new Router({
  //mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "features",
      component: Features
    },
    {
      path: "/customer-needs",
      name: "customer-needs",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/CustomerNeeds.vue")
    },
    {
      path: "/signal-store",
      name: "signal-store",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/SignalStore.vue")
    },
    {
      path: "/time-management",
      name: "time-management",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/TimeManagement.vue")
    },
    {
      path: "/location-services",
      name: "location-services",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/LocationServices.vue")
    },
    {
      path: "/operational-planning",
      name: "operational-planning",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/OperationalPlanning.vue")
    },
    {
      path: "/operational-monitoring",
      name: "operational-monitoring",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/OperationalMonitoring.vue")
    },
    {
      path: "/driving-style",
      name: "driving-style",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "about" */ "./views/DrivingStyle.vue")
    }
  ]
});
